module.exports = __webpack_public_path__ + "partfolioCover.d1c07a305af220cb7536.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/partfolioCover.jpg
// module id = ../../../../../src/assets/coverPicks/partfolioCover.jpg
// module chunks = 0